import {AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {InstallModel} from '../../../_models/CapaModels/install.model';
import {Observable, Subject} from 'rxjs';
import {OAuthService} from 'angular-oauth2-oidc-codeflow';
import {AuthenticationService} from '../../../_services/authentication.service';
import {Router} from '@angular/router';
import {ApiCapaService} from '../../../_services/apiCapa.service';
import {DataTableDirective} from 'angular-datatables';


@Component({
  selector: 'app-license-list',
  templateUrl: './license-list.component.html',
  styleUrls: ['./license-list.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class LicenseListComponent implements AfterViewInit, OnInit, OnDestroy {

    private _allLicenses: InstallModel[] = [];

    // DataTable licenses
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    dtOptions: DataTables.Settings = {};
    dtTrigger: Subject<any> = new Subject();
    public license: Observable<InstallModel>;

    get allLicenses() {
        return this._allLicenses;
    }

    set allLicenses(val: InstallModel[]) {
        this._allLicenses = val;
    }

    constructor(private oauthService: OAuthService, private cdRef: ChangeDetectorRef, private authenticationService: AuthenticationService,
                private router: Router, private ApiClient: ApiCapaService) {
    }

    goToLicense(license: InstallModel) {
        const idInstall = license ? license.idInstall : null;
        this.router.navigate(['capa/license/view', idInstall]);
    }

    ngOnInit() {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 15
        };
    }

    ngOnDestroy(): void {
        // Do not forget to unsubscribe the event
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.ApiClient.get('Installs/with-base-count').subscribe(licenses => {
            if (licenses) {
                this.allLicenses = licenses;
                this.dtTrigger.next();
            }
        }, error => {
            console.error('get license error', error);
        });
    }

    rerender(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            // Destroy the table first
            dtInstance.destroy();

            this.ApiClient.get('Installs/with-base-count').subscribe(licenses => {
                if (licenses) {
                    this.allLicenses = licenses;
                    this.dtTrigger.next();
                }
            }, error => {
                console.error('get license error', error);
            });
        });
    }
}
